import { reduxType } from "../../interfaces/reducerType"
const defaultState: any = "0";
function reducer(state = defaultState, { type, payload }: reduxType) {
    switch (type) {
        case "setIdColector":
            return payload
        default:
            return state;
    }
}
export default reducer;